import { ReactNode, RefObject } from 'react'
import styled from 'styled-components'

import { Stylable } from 'utils/types'

const MenuWrapper = styled.div`
  position: absolute;
  top: 60px;
  right: 0px;
  width: 350px;
  border-radius: 16px;
  border: 1px solid ${p => p.theme.colors.divider};
  box-shadow: 0px 0px 20px 0px ${p => p.theme.colors.menu.boxShadow};
  background: ${p => p.theme.colors.background.primary};
`

const MenuItemWrapper = styled.div`
  margin: 8px;
  cursor: pointer;
  display: flex;
  border-radius: 16px;
`

const MenuItemChild = styled.div`
  padding: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:hover {
    background-color: ${p => p.theme.colors.background.hover};
  }
`

interface MenuProps extends Stylable {
  anchorElement: RefObject<HTMLDivElement | null>
  children: ReactNode
}

export const Menu = ({ anchorElement, children, style, className }: MenuProps) => {
  return (
    <MenuWrapper ref={anchorElement} style={style} className={className}>
      {children}
    </MenuWrapper>
  )
}

interface MenuItemProps {
  onClick: () => void
  children: ReactNode
}

export const MenuItem = ({ children, onClick }: MenuItemProps) => {
  return (
    <MenuItemWrapper onClick={onClick}>
      <MenuItemChild>{children}</MenuItemChild>
    </MenuItemWrapper>
  )
}
